
export function getErrors(validationErrors){
    const formattedErrors = {};
    validationErrors.inner.forEach((error) => {
        formattedErrors[error.path] = error.message;
    })
    return formattedErrors;
}

export function getNewJournalErros(validationErrors){
    const formattedErrors = {};
    validationErrors.inner.forEach((error) => {
        formattedErrors[error.path] = error.message;
    })
    return formattedErrors;
}